import { AbstractControl, FormControl } from "@angular/forms";
import { FormlyFieldConfig } from "@ngx-formly/core";

export function ipValidator(control: AbstractControl, form: FormlyFieldConfig, options: any = {}) {
  const model = control.value;

  if(!model){
    return null;
  }

  return !control.value || /(\d{1,3}\.){3}\d{1,3}/.test(model)
  ? null
  : { ip: true };
}
